import { TextField, useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import FormFieldBase from './FormFieldBase';

function FormTextField ({
  label = undefined,
  placeholder = undefined,
  field,
  width = '100%',
  disabled = false,
  rows = 1,
  formatter = undefined,
  onBlur,
  fieldName = '',
  form = undefined,
}) {
  const theme = useTheme();
  const style = styles(theme, width);
  // Retrocompatibility
  const formField = form ? form.getFieldByName(fieldName) : field;
  const rawValue = formField.value;
  const value = formatter ? formatter.format(rawValue) : rawValue;
  const readonly = form ? form.isReadonly(fieldName) : false;

  return (
    <FormFieldBase>
      <TextField
        placeholder={placeholder || label}
        label={label}
        required={!formField.isOptional}
        InputLabelProps={{ shrink: !!value }}
        disabled={disabled || readonly}
        multiline={rows > 1}
        rows={rows}
        error={formField.hasValue && !formField.isValid}
        style={style.fieldContainer}
        value={value}
        onChange={(event) => {
          const newValue = formatter ? formatter.unformat(event.target.value) : event.target.value;
          formField.updateValue(newValue);
        }}
        onBlur={async (event) => {
          const newValue = formatter ? formatter.unformat(event.target.value) : event.target.value;
          const initialValue = formatter ? formatter.unformat(formField.initialValue()) : formField.initialValue();

          if (newValue !== initialValue) {
            formField.updateInitialValue(newValue);
            if (onBlur) {
              onBlur(event);
            } else {
              if (form) {
                await form.updateFieldWithValue(fieldName, newValue)
              } else {
                field.updateValue(newValue)
              }
            }
          }
        }}
          sx={{'& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root': {
          fontSize: '.8rem',
          },
      }}
      />
    </FormFieldBase>
  );
}

const styles = (theme, width) => ({
  fieldContainer: {
    backgroundColor: theme.brand.field,
    justifyContent: 'center',
    borderRadius: '0.5rem',
    width: width,
  },
});

export default observer(FormTextField);